<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card card-box mb-5">
                    <div class="card-body">
                        <div class="row justify-content-center">
                            <div class="col-md-8">
                                <div class="card card-box">
                                    <div class="card-header text-uppercase justify-content-center">
                                        <h3 class="text-center" style="font-weight:600">Detail pembelian paket</h3>
                                    </div>
                                    <div class="card-body">
                                        <div class="row" v-if="typePaket.berlangganan">
                                            <div class="col-md-4 mt-2">
                                                <strong>Jenis Paket</strong>
                                            </div>
                                            <div class="col-md-8 mt-2">
                                                <vue-select
                                                    class="align-content-right float-right w-50"
                                                    clearable=false
                                                    :options="dataPaket"
                                                    v-model="selectedPaket"
                                                    :reduce="dataPaket => dataPaket.value"
                                                    :disabled='statusPaket'
                                                />
                                            </div>
                                            <template v-if="showLamaBerlangganan">
                                                <div class="col-md-4 mt-2 pr-md-0">
                                                        <strong>Lama Berlangganan</strong>
                                                </div>
                                                <div class="col-md-8 mt-2">
                                                    <vue-select
                                                        class="align-content-right float-right w-50"
                                                        clearable=false
                                                        :options="optionLangganan" v-model="lama_langganan"
                                                        :disabled='(statusLamaDisabled && !statusDisabled) || statusDisabled'
                                                        />
                                                </div>
                                            </template>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-8 mt-2 pr-md-0">
                                                <strong>Adds on Patient Engagement </strong>
                                                <b-badge
                                                    class="badge-alert"
                                                    id="popover-info"
                                                >
                                                    <font-awesome-icon icon="info"/>
                                                </b-badge>
                                                <b-popover target="popover-info" triggers="hover" placement="topright">
                                                    <small>Anda dapat mengirimkan pesan reminder konsultasi, ucapan selamat ulang tahun bagi pasien Anda melalui SMS / Whatsapp</small>
                                                </b-popover>
                                            </div>
                                            <div class="col-md-4 mt-2 p-0">
                                                <b-form-checkbox
                                                    v-model="checkedAddOn"
                                                    switch
                                                    :disabled="addon_free || totalPrice.addon_promo"
                                                >
                                                </b-form-checkbox>
                                            </div>
                                        </div>
                                        <template v-if="checkedAddOn">
                                            <div class="row pt-3 px-5" v-for="(addOn, index) in dataAddOn" :key="index">
                                                <div class="col-md-8 mt-2 pr-md-0" v-if="addOn.tipe == 'sms'">
                                                    <strong>SMS {{ addOn.kuota }} Pesan</strong>
                                                </div>
                                                <div class="col-md-8 mt-2 pr-md-0" v-else-if="addOn.tipe == 'whatsapp'">
                                                    <strong>Whatsapp {{ addOn.kuota }} Pesan</strong>
                                                </div>
                                                <div class="col-md-8 mt-2 pr-md-0" v-else>
                                                    <strong>Email {{ addOn.kuota }} Pesan</strong>
                                                </div>
                                                <div class="col-md-4 mt-2">
                                                    <b-form-checkbox
                                                        v-model="checkboxAddOn"
                                                        :value="addOn.id"
                                                        :disabled="addon_free"
                                                        :style="checkboxStyle(addOn.id)"
                                                    >
                                                    <div class="real-price mr-2" v-if="addOn.harga != addOn.harga_real">
                                                        Rp{{ addOn.harga_real.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                    </div>
                                                    
                                                    {{ " &nbsp;&nbsp;&nbsp;" }} Rp{{ addOn.harga.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-

                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                        </template>

                                        <div class="row">
                                            <div class="col-md-7 mt-3 mb-2">
                                                <strong>Kode Promo</strong>
                                            </div>
                                            <div class="col-md-5 mt-3 mb-2">
                                                <div class="row float-right">
                                                    <div class="col-md-5 p-0">
                                                        <b-form-input v-model="kode_promo"></b-form-input>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <b-button
                                                            variant="primary"
                                                            @click="checkKodePromo"
                                                            class="text-uppercase btn-radius"
                                                            style="width:100%;min-width:105px;"
                                                            :disabled="this.kode_promo == null || this.kode_promo == '' ? true : false"
                                                        >
                                                            Submit
                                                        </b-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="text-center p-3 m-3" style="background-color : yellow" v-if="this.statusPromo">
                                                    <strong style="color:black">{{this.statusPromo}}</strong>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12 pr-md-0">
                                                <strong>Detail Pembelian</strong>
                                            </div>
                                            <div class="col-md-12">
                                                <div
                                                    class="card mt-3 mb-3 p-4 shadow-none border"
                                                    :style="statusDisabled ? 'background-color:#F4F4F4' : ''"
                                                >
                                                    <div class="row" v-if="typePaket.berlangganan">
                                                        <div class="col-md-7 my-3">
                                                            <strong>Harga Paket {{ selectedPaket.label }}</strong>
                                                            <!-- <template v-if="lama_langganan.value == 12 && !totalPrice.paket_promo">
                                                                <div class="col-md-12 p-0">
                                                                    <label class="small text-black-50"><strong>Hemat 16,6%</strong></label>
                                                                </div>
                                                            </template> -->
                                                            <template v-if="totalPrice.paket_promo || dataDetail.is_discount_date">
                                                                <div class="row" v-if="totalPrice.paket_promo">
                                                                    <div class="col-md-12 p-0" v-if="!totalPrice.paket_pay > 0">
                                                                        <label class="text-danger">
                                                                            <strong>
                                                                                GRATIS
                                                                            </strong>
                                                                        </label>
                                                                    </div>
                                                                    <div class="col-md-12 p-0" v-else-if="promoPaket.satuan == 'rupiah'">
                                                                        <label class="small text-black-50">
                                                                            <strong>
                                                                                Discount Rp. {{ promoPaket.value.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}},-
                                                                            </strong>
                                                                        </label>
                                                                    </div>
                                                                    <div class="col-md-12 p-0" v-else-if="promoPaket.satuan == 'percent'">
                                                                        <label class="small text-black-50"><strong>Discount {{ promoPaket.value }}%</strong></label>
                                                                    </div>
                                                                </div>
                                                                <div class="row" v-if="dataDetail.is_discount_date">
                                                                    <div class="col-md-7">
                                                                        <label class="small text-black-50"><strong>Discount {{ dataDetail.discount_date_value }}</strong></label>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <div class="col-md-5 my-3">
                                                            <template v-if="!isNaN(totalPrice.paket_real)">
                                                                <!-- <template v-if="lama_langganan.value == 12 && !totalPrice.paket_promo">
                                                                    <div class="text-right mr-3 ml-2">
                                                                        <strong>
                                                                            Rp. {{ totalPrice.paket_pay.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                        </strong> <br>
                                                                        <span class="outer">
                                                                            <span class="inner">
                                                                                Rp. {{ totalPrice.paket_real.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                </template> -->
                                                                <template v-if="totalPrice.paket_promo || dataDetail.is_discount_date">
                                                                    <div class="text-right mr-3 ml-2">
                                                                        <strong>
                                                                            Rp. {{ totalPrice.paket_pay.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                        </strong> <br>
                                                                        <span class="outer">
                                                                            <span class="inner">
                                                                                Rp. {{ totalPrice.paket_real.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <strong class="float-right mr-3">
                                                                        Rp. {{ totalPrice.paket_real.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                    </strong>
                                                                </template>
                                                            </template>
                                                        </div>

                                                        <div class="col-md-7 my-3">
                                                            <strong>Harga Add-On (Patient Engagement)</strong>
                                                            <template v-if="totalPrice.addon_promo">
                                                                <div class="col-md-12 p-0" v-if="!totalPrice.addon_pay > 0">
                                                                    <label class="text-danger">
                                                                        <strong>
                                                                            GRATIS
                                                                        </strong>
                                                                    </label>
                                                                </div>
                                                                <div class="col-md-12 p-0" v-else-if="promoAddOn.satuan == 'rupiah'">
                                                                    <label class="small text-black-50">
                                                                        <strong>
                                                                            Discount Rp. {{ promoAddOn.value.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}},-
                                                                        </strong>
                                                                    </label>
                                                                </div>
                                                                <div class="col-md-12 p-0" v-else-if="promoAddOn.satuan == 'percent'">
                                                                    <label class="small text-black-50"><strong>Discount {{ promoAddOn.value }}%</strong></label>
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <div class="col-md-5 my-3">
                                                            <template v-if="!isNaN(totalPrice.addon_real)">
                                                                <template v-if="totalPrice.addon_promo">
                                                                    <div class="text-right mr-3 ml-2">
                                                                        <strong>
                                                                            Rp. {{ totalPrice.addon_pay.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                        </strong> <br>
                                                                        <span class="outer">
                                                                            <span class="inner">
                                                                                Rp. {{ totalPrice.addon_real.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <strong class="float-right mr-3">
                                                                        Rp. {{ totalPrice.addon_real.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                    </strong>
                                                                </template>
                                                            </template>
                                                        </div>
                                                    </div>

                                                    <div class="row" v-else>
                                                        <div class="col-md-6 my-3">
                                                            <strong>Harga Add-On (Patient Engagement)</strong>
                                                            <template v-if="totalPrice.addon_promo">
                                                                <div class="col-md-12 p-0" v-if="promoAddOn.satuan == 'rupiah'">
                                                                    <label class="small text-black-50">
                                                                        <strong>
                                                                            Discount Rp. {{ promoAddOn.value.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}},-
                                                                        </strong>
                                                                    </label>
                                                                </div>
                                                                <div class="col-md-12 p-0" v-else-if="promoAddOn.satuan == 'percent'">
                                                                    <label class="small text-black-50"><strong>Discount {{ promoAddOn.value }}%</strong></label>
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <div class="col-md-6 my-3">
                                                            <template v-if="!isNaN(totalPrice.addon_real)">
                                                                <template v-if="totalPrice.addon_promo">
                                                                    <div class="text-right mr-3 ml-2">
                                                                        <strong>
                                                                            Rp. {{ totalPrice.addon_pay.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                        </strong> <br>
                                                                        <span class="outer">
                                                                            <span class="inner">
                                                                                Rp. {{ totalPrice.addon_real.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <strong class="float-right mr-3">
                                                                        Rp. {{ totalPrice.addon_real.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                    </strong>
                                                                </template>
                                                            </template>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <template v-if="dataPaygetDetail.biaya_admin > 0 && !statusDisabled">
                                                            <div class="col-md-6 my-3">
                                                                <strong>Biaya Admin</strong>
                                                            </div>
                                                            <div class="col-md-6 my-3">
                                                            <strong class="float-right mr-3">Rp.
                                                                {{ dataPaygetDetail.biaya_admin.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-</strong>
                                                            </div>
                                                        </template>
                                                        <div class="col-md-6 my-3">
                                                            <strong>Total Pembayaran</strong>
                                                            <template v-if="totalPrice.total_promo">
                                                                <div class="col-md-12 p-0" v-if="promoTotal.satuan == 'rupiah'">
                                                                    <label class="small text-black-50">
                                                                        <strong>
                                                                            Discount Rp. {{ promoTotal.value.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}},-
                                                                        </strong>
                                                                    </label>
                                                                </div>
                                                                <div class="col-md-12 p-0" v-if="promoTotal.satuan == 'percent'">
                                                                    <label class="small text-black-50"><strong>Discount {{ promoTotal.value }}%</strong></label>
                                                                </div>
                                                            </template>
                                                            <template v-else-if="!totalPrice.total_pay > 0">
                                                                <div class="col-md-12 p-0">
                                                                    <label class="text-danger">
                                                                        <strong>
                                                                            GRATIS
                                                                        </strong>
                                                                    </label>
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <div class="col-md-6 my-3">
                                                            <template v-if="!isNaN(totalPrice.total_real)">
                                                                <template v-if="totalPrice.total_promo">
                                                                    <div class="text-right mr-3 ml-2">
                                                                        <strong>
                                                                            Rp. {{ totalPrice.total_pay.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                        </strong> <br>
                                                                        <span class="outer">
                                                                            <span class="inner">
                                                                                Rp. {{ totalPrice.total_real.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <strong class="float-right mr-3">
                                                                        Rp. {{ totalPrice.total_pay.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") }},-
                                                                    </strong>
                                                                </template>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12 pr-md-0">
                                                <strong>Pilih Metode Pembayaran</strong>
                                            </div>
                                            <div class="col-md-12">
                                                <div
                                                    class="card mt-3 mb-3 p-4 shadow-none border"
                                                    :style="statusDisabled ? 'background-color:#F4F4F4' : ''"
                                                >
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <b-form-group class="p-0 my-3" v-slot="{ ariaDescribedby }" v-for="item in dataPaygate"
                                                                :key="item.value" :disabled='statusDisabled'>
                                                                <b-form-radio v-model="selectedPaygate" :aria-describedby="ariaDescribedby"
                                                                name="some-radios" :value="item.value" :class="item.value == 3 ? 'mb-0'  : 'mb-3'">
                                                                {{item.label}}</b-form-radio>
                                                            </b-form-group>
                                                        </div>
                                                        <div class="col-md-6 float-right">
                                                            <b-form-group class="p-0 my-3" v-for="item in dataPaygate" :key="item.value">
                                                                <img :src="item.logo" class="float-right" width="82" height="26"
                                                                style="margin-bottom:0.8rem">
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-3 offset-4">
                                            <div class="col-md-5 p-0 text-right">
                                                <b-button
                                                    @click="kembali"
                                                    variant="danger"
                                                    class="text-uppercase mr-3 btn-radius"
                                                    style="width:100%;"
                                                >
                                                    Kembali
                                                </b-button>
                                            </div>
                                            <div class="col-md-5 offset-1 p-0 text-center">
                                                <template v-if="typePaket.berlangganan">
                                                    <b-button
                                                        @click="checkSubscribe"
                                                        variant="primary"
                                                        class="text-uppercase btn-radius"
                                                        style="width:100%;"
                                                    >
                                                        Selesaikan
                                                    </b-button>
                                                </template>
                                                <template v-if="typePaket.add_on">
                                                    <b-button
                                                        @click="checkSubscribe"
                                                        variant="primary"
                                                        class="text-uppercase btn-radius"
                                                        :disabled="checkboxAddOn.length > 0 ? false : true"
                                                        style="width:100%;"
                                                    >
                                                        Selesaikan
                                                    </b-button>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import startCase from "lodash/startCase";
    import {
        mapMutations, mapGetters
    } from "vuex";
    import {
        library
    } from "@fortawesome/fontawesome-svg-core";
    import {
        faInfo
    } from "@fortawesome/free-solid-svg-icons";
    library.add(
        faInfo
    );
    export default {
        components: {
        "vue-select": () => import("@/components/VueSelect.vue")
        },
        data() {
            return {
                lama_langganan: {},
                firstPaygate: true,
                kode_promo: null,
                id_promo: null,
                statusPromo: null,
                statusDisabled: false,
                statusLamaDisabled: false,
                is_clickPromo: false,
                billing_id: null,
                dataDetail: [],
                dataPaygate: [],
                dataPaygetDetail: [],
                selectedPaygate: null,
                optionLangganan: [],
                dataPaket: [],
                statusPaket: false,
                selectedPaket: {},
                checkedAddOn: true,
                dataAddOn: [],
                priceAddOn: 0,
                checkboxAddOn: [],
                typePaket: {
                    berlangganan: this.$router.currentRoute.params.type == 'berlangganan' ? true : false,
                    add_on: this.$router.currentRoute.params.type == 'add-on' ? true : false
                },
                promoPaket: [],
                promoAddOn: [],
                promoTotal: [],
                totalPrice: [],
                addon_free: false,
                showLamaBerlangganan: false
            }
        },
        beforeRouteLeave(to, from, next) {
            next();
        },
        computed: {
            ...mapGetters(["getKlinikId"]),
        },
        mounted() {
            this.fetchPaket();
            this.totalPriceAddOn();
        },
        watch: {
            selectedPaket(val) {
                // this.fetchDetailPaket(this.selectedPaket);
                if(this.kode_promo != null) this.checkKodePromo();

                this.dataDetail = val;

                if(val.nama == 'Unlimited') {
                    this.showLamaBerlangganan = true;
                    this.lama_langganan = this.optionLangganan[0];
                }
                else {
                    this.showLamaBerlangganan = false;
                }

                this.countPrice();
            },
            selectedPaygate() {
                this.getPaygetDetail(this.selectedPaygate);
            },
            checkedAddOn() {
                if(this.checkedAddOn) {
                    this.checkedAll()
                } else {
                    this.checkboxAddOn = []
                }
                this.totalPriceAddOn();
            },
            checkboxAddOn() {
                this.totalPriceAddOn()
            },
            lama_langganan(val) {
                // this.dataDetail = val;
                // this.countPrice();
            }
        },
        methods: {
            ...mapMutations({
                collapseSidebar: "sidebar/SET_SIDEBAR_COLLAPSED",
                setInitPage: "sidebar/SET_INITIALIZATION_PAGE",
                setUserFirstLogin: "SET_USER_FIRST_LOGIN"
            }),
            kembali() {
                this.fetchBerlangganan()
                if (this.is_clickPromo || this.statusDisabled || this.statusLamaDisabled) {
                    this.$nextTick(() => {
                        this.selectedPaygate = 1;

                        this.selectedPaket = {
                            label: "Starter",
                            value: 2
                        }
                        this.statusDisabled = this.statusLamaDisabled = this.is_clickPromo = this.statusPaket = false
                        this.statusPromo = this.id_promo = this.kode_promo = this.statusPotongan = null
                        this.promoPaket = this.promoAddOn = this.promoTotal = []
                    });
                } else {
                    this.$router.push({
                        name: 'klinik-subskripsi'
                    });
                }
            },
            rerender(id) {
                this.$root.$emit("rerender", id);
            },
            async checkKodePromo() {
                try {
                    let paket = this.dataDetail.id != undefined ? { paket:this.selectedPaket.id } : null
                    let addon = this.typePaket.add_on ? { addon: this.typePaket.add_on } : null
                    const res = await this.$axios.post(`promo`, { klinik_id: this.getKlinikId,
                        ...{kode: this.kode_promo}, ...paket, ...addon
                    })

                    if(res.data.data == null) {
                        this.statusPromo = res.data.message
                        this.promoPaket = this.promoAddOn = this.promoTotal = []
                    } else {
                        let dataPromo = res.data.data.promos

                        this.statusPromo = res.data.message
                        this.id_promo = res.data.data.id;
                        this.is_clickPromo = true;

                        this.promoPaket = this.promoAddOn = this.promoTotal = []
                        dataPromo.forEach(val => {
                            if(val.tipe == 'paket') {
                                this.promoPaket = val
                            } else if(val.tipe == 'addon') {
                                this.promoAddOn = val
                            } else if(val.tipe == 'total') {
                                this.promoTotal = val
                            }
                        })
                        
                        if(this.typePaket.berlangganan) {
                            if(this.promoPaket.value != undefined) {
                                this.statusPaket = this.promoPaket.applied_to.length > 1 ? false : true
                                let appliedTo = []
                                this.dataPaket.forEach(x => {
                                    if(this.promoPaket.applied_to.includes(x.id)) {
                                        appliedTo.push(x)
                                    }
                                })
                                this.dataPaket = appliedTo
                            }

                            if (this.promoPaket.duration != null) {
                                if(this.promoPaket.is_promo) {
                                    this.lama_langganan = {
                                        label: `${this.promoPaket.duration} Bulan (Promo)`,
                                        value: this.promoPaket.duration
                                    };
                                } else {
                                    this.lama_langganan = {
                                        label: `${this.promoPaket.duration} Bulan`,
                                        value: this.promoPaket.duration
                                    };
                                }
                                this.statusLamaDisabled = true
                            } else if (this.promoPaket.duration == null) {
                                this.statusLamaDisabled = false
                            }
                        }

                        if(this.promoAddOn.value != undefined && !this.checkedAddOn) {
                            this.checkedAddOn = true
                            this.checkedAll()
                        }
                    }
                    this.countPrice()

                } catch {
                    this.statusDisabled = this.statusLamaDisabled = false
                    this.selectedPaygate = 1;

                    this.selectedPaket = {
                        label: "Starter",
                        value: 2
                    }
                    this.is_clickPromo = true
                    this.zz = this.kode_promo = null
                    this.countPrice()
                }
            },
            checkSubscribe() {
                let type = null;
                if(this.typePaket.add_on) {
                    type = 'Add-On';
                } else {
                    type = 'paket';
                }

                let buyPaket =  this.typePaket.berlangganan
                let buyAddon = this.checkedAddOn

                let subj = ''
                if (buyPaket && buyAddon) {
                    subj = 'Paket dan Add-On'
                } else if(buyPaket){
                    subj = 'Paket'
                } else if(buyAddon){
                    subj = 'Add-On'
                }

                if(this.totalPrice.total_pay < 10000 && this.selectedPaygate == 2) {
                    this.$swal({
                        title: startCase("Pembayaran Gagal"),
                        text: `Minimal pembayaran BCA Virtual Account Rp. 10.000,-`,
                        type: "error"
                    });
                } else {
                    let alertText = `
                    Apakah Anda yakin untuk menyelesaikan pembelian `+type+` ini?<span style='color: red'>*</span>
                    <br>
                    <div style="color: red; font-size: 15px">*${subj} yang sudah dibeli tidak dapat dikembalikan</div>
                    `
                    this.$swal({
                        type: 'warning',
                        title: startCase("Pembayaran"),
                        text: alertText,
                        showCancelButton: true,
                        cancelButtonText: startCase("Tidak"),
                        confirmButtonText: startCase("Ya"),
                        confirmButtonColor: "#1791EE",
                        html: alertText
                    }).then(res => {
                        if (res.value) {
                            this.prosesBayar();
                        }
                        // if (res.value && this.typePaket.berlangganan) {
                        //     this.$axios.get(`check-subscribe`)
                        //     .then(res => {
                        //         if (res.data.status) {
                        //             this.$swal({
                        //                 type: 'warning',
                        //                 text: `Kuota Free Trial Anda akan hangus dan Anda akan menggunakan kuota baru dari paket yang akan Anda beli. Apakah Anda ingin melanjutkan pembelian paket?`,
                        //                 confirmButtonText: "YA, LANJUTKAN",
                        //                 showCancelButton: true,
                        //                 cancelButtonText: "TIDAK",
                        //                 allowOutsideClick: false,
                        //                 allowEscapeKey: false,
                        //                 cancelButtonColor: '#F0211B',
                        //             }).then(res => {
                        //                 if (res.value) {
                        //                     this.prosesBayar();
                        //                 }
                        //             });
                        //         } else {
                        //             this.prosesBayar();
                        //         }
                        //     });
                        // } else if(res.value && this.typePaket.add_on) {
                        //     this.prosesBayar();
                        // }
                    });
                }
            },
            async prosesBayar() {
                try {
                    let res;
                    res = await this.$axios.post(`subscribe`, {
                        klinik_id: this.getKlinikId,
                        pg_id: this.selectedPaygate,
                        promo_id: this.id_promo || this.dataDetail.discount_date_id,
                        paket_id: this.dataDetail.id,
                        amount_disc: this.totalPrice.total_pay,
                        amount_real: this.totalPrice.total_real,
                        paket_bln: this.dataDetail.bulan,
                        paket: this.typePaket.berlangganan,
                        addon: this.checkedAddOn,
                        addon_data: this.addOnChecked(),
                    });

                    if (res.data.is_free) {
                        this.$axios.get(`user/finish?klinik_id=${this.getKlinikId}`)
                        this.setUserFirstLogin(0);
                        this.$swal({
                            html: `${res.data.message}`,
                            type: "success"
                        }).then(res => {
                            if (res.value) {
                                this.$router.push({
                                    name: 'klinik-subskripsi',
                                });
                            }
                        });
                    } else {
                        if (res.data.status || res.data.success) {
                            this.$axios.get(`user/finish?klinik_id=${this.getKlinikId}`)
                            this.setUserFirstLogin(0);
                            this.billing_id = res.data.billing_id;
                            if (this.selectedPaygate === 1) {
                                window.open(res.data.redirect_url, '_self');
                            } else if(this.billing_id != undefined) {
                                this.$router.push({
                                    name: 'klinik-subskripsi-bayar',
                                    params: {
                                        bill_id: this.billing_id
                                    }
                                });
                            } else {
                                this.$axios.get(`user/finish?klinik_id=${this.getKlinikId}`)
                                this.setUserFirstLogin(0);
                                this.$swal({
                                    html: `${res.data.message}`,
                                    type: "success"
                                }).then(res => {
                                    if (res.value) {
                                        this.$router.push({
                                            name: 'klinik-subskripsi',
                                        });
                                    }
                                });
                            }
                        } else {
                            this.setInitPage(false);
                            this.setUserFirstLogin(0);
                            this.$swal({
                                title: startCase("Pembayaran Gagal"),
                                text: `Pembayaran gagal dibuat`,
                                type: "error"
                            });
                        }
                    }
                } catch {

                }
            },
            async getPaygetDetail(data) {
                let getdet = data;
                if(getdet != null) {
                    let res = await this.$axios.get(`paygate/${getdet}`)
                    
                    this.dataPaygetDetail = res.data.data
                    this.countPrice()
                }
            },
            async fetchDetailPaket(data) {
                let id = data.value;
                let res = await this.$axios.get(`paket/${id}?klinik_id=${this.getKlinikId}`)
                
                this.dataDetail = res.data.data
                this.countPrice()

                if(res.data.data.limit == 'Unlimited'){
                    this.showLamaBerlangganan = true;
                }else{
                    this.showLamaBerlangganan = false;
                }

            },
            fetchPaket() {
                this.fetchBerlangganan()

                this.$axios.get(`paygate`)
                .then(res => {
                    res.data.data.paygate.forEach(item => {
                        this.dataPaygate.push({
                            label: `${item.nama}`,
                            value: item.id,
                            logo: item.logo,
                        })
                    })
                    if (this.firstPaygate === true) {
                        this.selectedPaygate = res.data.data.paygate[0].id;
                        this.getPaygetDetail(this.selectedPaygate);
                        this.firstPaygate = false;
                    }
                });

                this.$axios.get(`addson`)
                .then(res => {
                    if(res.data.success) {
                        this.dataAddOn = res.data.data
                        this.checkedAll();
                    }
                });
            },
            totalPriceAddOn() {
                let price = 0
                this.dataAddOn.forEach(value => {
                    if(this.checkboxAddOn.includes(value.id)) {
                        price += parseInt(value.harga)
                    }
                })
                this.priceAddOn = price
                this.countPrice()
            },
            addOnChecked() {
                let data = []
                this.checkboxAddOn.forEach(x => {
                    data.push({id: x})
                })
                return data
            },
            checkedAll() {
                let checked = []
                this.dataAddOn.forEach(x => {
                    checked.push(x.id)
                })
                this.checkboxAddOn = checked
            },
            countPrice() {
                let paket_real = 0
                let paket_pay = 0
                let addon_real = 0
                let addon_pay = 0
                let total_real = 0
                let total_pay = 0
                let paket_promo = false
                let addon_promo = false
                let total_promo = false
                let admin = isNaN(this.dataPaygetDetail.biaya_admin) ? 0 : this.dataPaygetDetail.biaya_admin
                if(this.typePaket.berlangganan) {
                    // if(this.lama_langganan.value == 12) {
                    //     if(this.promoPaket.value != undefined) {
                    //         if(this.promoPaket.satuan == 'rupiah') {
                    //             paket_real = this.dataDetail.harga * 10
                    //             paket_pay = (this.dataDetail.harga * 10) - this.promoPaket.value
                    //         } else if(this.promoPaket.satuan == 'percent' && this.promoPaket.value < 100) {
                    //             paket_real = this.dataDetail.harga * 10
                    //             paket_pay = (this.dataDetail.harga * 10) * (this.promoPaket.value / 100)
                    //         }
                    //         paket_promo = true
                    //     } else {
                    //         paket_real = this.dataDetail.harga * this.lama_langganan.value
                    //         paket_pay = this.dataDetail.harga * 10
                    //     }
                    // } else 
                    if(this.promoPaket.value != undefined) {
                        if(this.promoPaket.satuan == 'rupiah') {
                            paket_real = this.dataDetail.harga/* * this.lama_langganan.value*/
                            paket_pay = (this.dataDetail.harga/* * this.lama_langganan.value*/) - this.promoPaket.value
                        } else if(this.promoPaket.satuan == 'percent' && this.promoPaket.value < 100) {
                            paket_real = this.dataDetail.harga/* * this.lama_langganan.value*/
                            paket_pay = (this.dataDetail.harga/* * this.lama_langganan.value*/ * (100 - this.promoPaket.value) / 100)
                        }
                        paket_promo = true
                    } else {
                        paket_real = this.dataDetail.harga/* * this.lama_langganan.value*/
                        paket_pay = this.dataDetail.harga/* * this.lama_langganan.value*/
                    }

                    // promo based on date not code
                    if (this.dataDetail.is_discount_date) {
                        paket_real = this.dataDetail.harga;
                        paket_pay = this.dataDetail.harga_diskon
                    } else {
                        paket_real = this.dataDetail.harga;
                        paket_pay = this.dataDetail.harga
                    }
                }

                if(this.promoAddOn.value != undefined) {
                    if(this.promoAddOn.satuan == 'rupiah') {
                        addon_real = this.priceAddOn
                        addon_pay = this.priceAddOn - this.promoAddOn.value
                    } else if(this.promoAddOn.satuan == 'percent') {
                        addon_real = this.priceAddOn
                        addon_pay = (this.priceAddOn * (100 - this.promoAddOn.value) / 100)
                        this.addon_free = this.promoAddOn.value == 100 ? true : false
                    }
                    addon_promo = true
                } else {
                    addon_real = this.priceAddOn
                    addon_pay = this.priceAddOn
                }

                if(this.promoTotal.value != undefined) {
                    if(this.promoTotal.satuan == 'rupiah') {
                        total_real = isNaN(paket_pay) ? (addon_pay + admin) : (paket_pay + addon_pay + admin)
                        total_pay = (isNaN(paket_pay) ? (addon_pay + admin) : (paket_pay + addon_pay + admin)) - this.promoTotal.value
                    } else if(this.promoTotal.satuan == 'percent') {
                        total_real = isNaN(paket_pay) ? (addon_pay + admin) : (paket_pay + addon_pay + admin)
                        total_pay = (isNaN(paket_pay) ? (addon_pay + admin) : (paket_pay + addon_pay + admin)) * (100 - this.promoTotal.value) / 100
                        this.addon_free = this.promoTotal.value == 100 ? true : false
                    }
                    total_promo = true
                } else {
                    total_real = isNaN(paket_real) ? (addon_real + admin) : (paket_real + addon_real + admin)
                    total_pay = isNaN(paket_pay) ? (addon_pay + admin) : (paket_pay + addon_pay + admin)
                }

                if(this.typePaket.berlangganan) {
                    this.statusDisabled = total_pay > 0 ? false : true
                } else {
                    this.statusDisabled = this.addon_free
                }

                if(this.statusDisabled) {
                    this.selectedPaygate = null
                    this.totalPrice = {
                        paket_real: 0,
                        paket_pay: 0,
                        paket_promo: false,
                        addon_real: 0,
                        addon_pay: 0,
                        addon_promo: false,
                        total_real: 0,
                        total_pay: 0,
                        total_promo: false,
                    }
                } else {
                    this.totalPrice = {
                        paket_real: isNaN(paket_real) ? 0 : paket_real,
                        paket_pay: isNaN(paket_pay) ? 0 : paket_pay,
                        paket_promo: paket_promo,
                        addon_real: isNaN(addon_real) ? 0 : addon_real,
                        addon_pay: isNaN(addon_pay) ? 0 : addon_pay,
                        addon_promo: addon_promo,
                        total_real: isNaN(total_real) ? 0 : total_real,
                        total_pay: isNaN(total_pay) ? 0 : total_pay,
                        total_promo: total_promo,
                    }

                }
            },
            checkboxStyle(id) {
                if(this.checkboxAddOn.length == 1 && this.checkboxAddOn[0] == id) {
                    return {'pointer-events':'none'}
                } 
            },
            fetchBerlangganan() {
                if(this.typePaket.berlangganan) {
                    this.$axios.get(`paket?klinik_id=${this.getKlinikId}`)
                    .then(res => {
                        const { data } = res.data
                        let unlimited_pushed = false;
                        data.paket.forEach(item => {
                            if(item.nama == 'Unlimited') {
                                this.optionLangganan.push({
                                    ...item,
                                    label: `${item.bulan} Bulan`,
                                    value: item.bulan
                                });

                                if(!this.unlimited_pushed) {
                                    this.dataPaket.push({
                                        ...item,
                                        label: item.nama,
                                        value: item.id
                                    });
                                    this.unlimited_pushed = true;
                                }
                            }
                            else {
                                this.dataPaket.push({
                                    ...item,
                                    label: item.nama,
                                    value: item.id
                                })
                            }
                        })

                        this.selectedPaket = this.dataPaket[0]
                        this.lama_langganan = this.optionLangganan[0];
                        this.countPrice();
                    });
                }
            }
        }
    };
</script>

<style scoped>
    .promo-code {
        color: #f83245;
        cursor: pointer;
    }
    .btn-radius {
        font-weight: bold;
        border-radius: 0.5em;
    }
    .badge-alert {
        color: #000000;
        background-color: #ffffff;
        border: solid 1px #000000;
        border-radius: 50%;
        cursor: pointer;
    
    }
    span.inner {
        color: #000000;
        font-weight: 500;
        font-size: 12px;
    }
    span.outer {
        position: relative;
    }
    span.outer:before {
        color: #f83245;
        position: absolute;
        content: "";
        left: 0;
        top: 50%;
        right: 0;
        border-top: 2px solid;
        border-color: inherit;

        -webkit-transform:rotate(-5deg);
        -moz-transform:rotate(-5deg);
        -ms-transform:rotate(-5deg);
        -o-transform:rotate(-5deg);
        transform:rotate(-5deg);
    }

    .real-price {
        display: inline;
        text-decoration: line-through;
        text-decoration-color: #f83245;
        text-decoration-thickness: 3px;
    }

    .asterisk {
        color: red !important;
    }

    .red-notice {
        color: red !important;
    }
</style>
